export const FETCH_APPOINTMENTS = "[RECEPTIONIST] FETCH_APPOINTMENTS";
export const FETCH_APPOINTMENTS_START = "[RECEPTIONIST] FETCH_APPOINTMENTS_START";
export const FETCH_APPOINTMENTS_SUCCESS = "[RECEPTIONIST] FETCH_APPOINTMENTS_SUCCESS";
export const FETCH_APPOINTMENTS_ERROR = "[RECEPTIONIST] FETCH_APPOINTMENTS_ERROR";

export const ADD_UPDATE_APPOINTMENT = "[RECEPTIONIST] ADD_UPDATE_APPOINTMENT";
export const ADD_UPDATE_APPOINTMENT_START = "[RECEPTIONIST] ADD_UPDATE_APPOINTMENT_START";
export const ADD_UPDATE_APPOINTMENT_SUCCESS = "[RECEPTIONIST] ADD_UPDATE_APPOINTMENT_SUCCESS";
export const ADD_UPDATE_APPOINTMENT_ERROR = "[RECEPTIONIST] ADD_UPDATE_APPOINTMENT_ERROR";

export const ADD_UPDATE_APPOINTMENT_EVENT = "[RECEPTIONIST] ADD_UPDATE_APPOINTMENT_EVENT";
export const ADD_UPDATE_APPOINTMENT_EVENT_START = "[RECEPTIONIST] ADD_UPDATE_APPOINTMENT_EVENT_START";
export const ADD_UPDATE_APPOINTMENT_EVENT_SUCCESS = "[RECEPTIONIST] ADD_UPDATE_APPOINTMENT_EVENT_SUCCESS";
export const ADD_UPDATE_APPOINTMENT_EVENT_ERROR = "[RECEPTIONIST] ADD_UPDATE_APPOINTMENT_EVENT_ERROR";

export const DELETE_APPOINTMENT_EVENT = "[RECEPTIONIST] DELETE_APPOINTMENT_EVENT";
export const DELETE_APPOINTMENT_EVENT_START = "[RECEPTIONIST] DELETE_APPOINTMENT_EVENT_START";
export const DELETE_APPOINTMENT_EVENT_SUCCESS = "[RECEPTIONIST] DELETE_APPOINTMENT_EVENT_SUCCESS";
export const DELETE_APPOINTMENT_EVENT_ERROR = "[RECEPTIONIST] DELETE_APPOINTMENT_EVENT_ERROR";

export const SET_SELECTED_APPOINTMENT = "[RECEPTIONIST] SET_SELECTED_APPOINTMENT";
export const SET_SELECTED_APPOINTMENT_START = "[RECEPTIONIST] SET_SELECTED_APPOINTMENT_START";
export const SET_SELECTED_APPOINTMENT_SUCCESS = "[RECEPTIONIST] SET_SELECTED_APPOINTMENT_SUCCESS";
export const SET_SELECTED_APPOINTMENT_ERROR = "[RECEPTIONIST] SET_SELECTED_APPOINTMENT_ERROR";
export const RESET_SELECTED_APPOINTMENT = "[RECEPTIONIST] RESET_SELECTED_APPOINTMENT";

export const SET_CALENDAR_RESOURCES = "[RECEPTIONIST] SET_CALENDAR_RESOURCES";

export const UPLOAD_APPOINTMENT_DOCUMENT = "[RECEPTIONIST] UPLOAD_APPOINTMENT_DOCUMENT";
export const UPLOAD_APPOINTMENT_DOCUMENT_SUCCESS = "[RECEPTIONIST] UPLOAD_APPOINTMENT_DOCUMENT_SUCCESS";
export const UPLOAD_APPOINTMENT_DOCUMENT_ERROR = "[RECEPTIONIST] UPLOAD_VISIT_DOCUMENT_ERROR";

export const FETCH_RESOURCE_AVAILABILITY_ROSTER = "[RECEPTIONIST] FETCH_RESOURCE_AVAILABILITY_ROSTER";
export const FETCH_RESOURCE_AVAILABILITY_ROSTER_START = "[RECEPTIONIST] FETCH_RESOURCE_AVAILABILITY_ROSTER_START";
export const FETCH_RESOURCE_AVAILABILITY_SUCCESS = "[RECEPTIONIST] FETCH_RESOURCE_AVAILABILITY_SUCCESS";
export const FETCH_RESOURCE_AVAILABILITY_ERROR = "[RECEPTIONIST] FETCH_RESOURCE_AVAILABILITY_ERROR";

export const CANCEL_APPOINTMENT = "[RECEPTIONIST] CANCEL_APPOINTMENT";
export const CANCEL_APPOINTMENT_SUCCESS = "[RECEPTIONIST] CANCEL_APPOINTMENT_SUCCESS";

export const LOAD_APPOINMENT_CALENDAR = "LOAD_APPOINMENT_CALENDAR";
export const LOAD_APPOINMENT_CALENDAR_START = "LOAD_APPOINMENT_CALENDAR_START";
export const LOAD_APPOINMENT_CALENDAR_SUCCESS = "LOAD_APPOINMENT_CALENDAR_SUCCESS";
export const LOAD_APPOINMENT_CALENDAR_ERROR = "LOAD_APPOINMENT_CALENDAR_ERROR";

export const VIEW_REFERENCE_DOCS = "VIEW_REFERENCE_DOCS";
export const VIEW_REFERENCE_DOCS_START = "VIEW_REFERENCE_DOCS_START";
export const VIEW_REFERENCE_DOCS_SUCCESS = "VIEW_REFERENCE_DOCS_SUCCESS";
export const VIEW_REFERENCE_DOCS_ERROR = "VIEW_REFERENCE_DOCS_ERROR"

export const FETCH_APPOINTMENTS_BY_MIP = "[RECEPTIONIST] FETCH_APPOINTMENTS_BY_MIP";
export const FETCH_APPOINTMENTS_BY_MIP_START = "[RECEPTIONIST] FETCH_APPOINTMENTS_BY_MIP_START";
export const FETCH_APPOINTMENTS_BY_MIP_SUCCESS = "[RECEPTIONIST] FETCH_APPOINTMENTS_BY_MIP_SUCCESS";
export const FETCH_APPOINTMENTS_BY_MIP_ERROR = "[RECEPTIONIST] FETCH_APPOINTMENTS_BY_MIP_ERROR";
export const SET_APPOINTMENTS_PAGINATION = "[RECEPTIONIST] SET_APPOINTMENTS_PAGINATION";

export const SET_CALENDAR_SLOT_EVENT = "[RECEPTIONIST] SET_CALENDAR_SLOT_EVENT";

export const UPDATE_APPOINTMENT_NOTES = "[RECEPTIONIST] UPDATE_APPOINTMENT_NOTES";
export const UPDATE_APPOINTMENT_AMR_NOTES = "[RECEPTIONIST] UPDATE_APPOINTMENT_AMR_NOTES";
export const UPDATE_PATIENT_NOTES = "[RECEPTIONIST] UPDATE_PATIENT_NOTES";

export const setCalendarSlotEvent = (payload) => {
  return {
    type: SET_CALENDAR_SLOT_EVENT,
    payload,
  };
};

export const updateAppointmentNotes = (appointmentId, notes) => ({
  type: UPDATE_APPOINTMENT_NOTES,
  payload: { appointmentId, notes },
});

export const updateAppointmentAmrNotes = (appointmentId, notes) => ({
  type: UPDATE_APPOINTMENT_AMR_NOTES,
  payload: { appointmentId, notes },
});

export const updatePatientNotes = (patientId, notes) => ({
  type: UPDATE_PATIENT_NOTES,
  payload: { patientId, notes },
});

export const loadAppiontmentCalendar = (payload) => {
    return {
        type: LOAD_APPOINMENT_CALENDAR,
        payload
    };
};

export const fetchResourceAvailablityRoster = (payload) => {
    return {
        type: FETCH_RESOURCE_AVAILABILITY_ROSTER,
        payload
    };
};

export const fetchAppointments = (data) => {
    return {
        type: FETCH_APPOINTMENTS,
        payload: data
    };
};

export const addUpdateAppointment = (appointment) => (dispatch) => {
    return new Promise((resolve) => {
        dispatch({
            type: ADD_UPDATE_APPOINTMENT,
            appointment: { ...appointment, resolve },
        });
    });
};

export const addUpdateAppointmentEvent = (event) => {
    return {
        type: ADD_UPDATE_APPOINTMENT_EVENT,
        event
    };
};

export const deleteAppointmentEvent = (payload) => {
    return {
        type: DELETE_APPOINTMENT_EVENT,
        payload
    };
};

export const uploadAppointmentDocument = (document) => {
    return {
        type: UPLOAD_APPOINTMENT_DOCUMENT,
        payload: { document }
    };
};

export const setSelectedAppointment = (appointmentId) => {
    return {
        type: SET_SELECTED_APPOINTMENT,
        appointmentId
    };
};

export const resetSelectedAppointment = () => {
    return {
        type: RESET_SELECTED_APPOINTMENT,
    };
};

export const setSelectedAppointmentDirect = (appointment) => {
    return {
        type: SET_SELECTED_APPOINTMENT_SUCCESS,
        appointment,
    };
};

export const cancelAppointment = (appointment) => {
    return {
        type: CANCEL_APPOINTMENT,
        payload: appointment
    }
}

export const viewReferenceDocuments = (appointmentId) => {
    return {
        type: VIEW_REFERENCE_DOCS,
        payload: { appointmentId }
    };
}

export const fetchAppointmentsByMip = (data) => {
    return {
        type: FETCH_APPOINTMENTS_BY_MIP,
        payload: data
    };
};